import React from 'react'

import {payouts} from '../../core/controllers/Payouts';
import DotProgress from '../../core/utilities/DotProgress';
export default class OwnerPayoutHistoryWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            payouts: null
        }
    }

    componentDidMount() {
        var self = this;
        payouts.getOwnerPayouts(function(response) {
            self.setState({
                payouts: response.data
            })
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        // format money
        var money = parseInt(value) / 100;
        money = Number(money.toFixed(2)).toLocaleString();
        if(money == 'NaN') { money = 0; }

        return money;
    }

    formatMoney(cell, row) {
        return '$' + this.formatAmount(cell);
    }

    formatStatus(cell, row) {
        var status = <DotProgress dotPos={2} date={row.due_at}/>
        if (cell == 'PAID') {
            status = <DotProgress dotPos={3} date={row.due_at}/>
        } else if (cell == 'VOID') {
            status = '<span class="important-small-gray">Cancelled</span>';
        } else if (cell == 'EXPIRED') {
            status = '<span class="important-small-red">Expired</span>';
        } else if (cell == 'FAILED') {
            status = '<span class="important-small-red">Failed</span>';
        } else if (cell == 'REFUNDED') {
            status = '<span class="important-small-blue">Refund</span>';
        } else if (cell == 'NONE') {
            status = <DotProgress dotPos={1} date={row.due_at}/>
        }

        return status;
    }

    formatDate(cell, row) {
        return moment(cell).format('MMMM Do YYYY');
    }

    formatMoney(cell, row) {
        return '$' + this.formatAmount((row.payout - row.fee_charge));
    }

    render(){
        var self        = this;
        var payouts     = this.state.payouts;

        if(payouts != null) {
            payouts = this.state.payouts.map(function(payout) {
                return {
                    payout_id: payout.payout.payout_id,
                    name: payout.payout.name,
                    company_name: payout.owner.company_name,
                    payout: payout.payout.payout,
                    fee_charge: payout.payout.fee_charge,
                    status: payout.status,
                    created_at: payout.payout.created_at
                }
            });
        }

        return (
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title">Payout History</h4>
                        <p class="category">List of all payouts sent to your account. <small>Payouts typically take 3 - 4 business days.</small></p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                            {payouts != null ? (
                                window.innerWidth < 992 ? (
                                <BootstrapTable data={payouts} version='4' striped search pagination hover>
                                    <TableHeaderColumn dataField='payout_id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                    <TableHeaderColumn dataField='payout' dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Amount</TableHeaderColumn>
                                    <TableHeaderColumn dataField='status' width="120" dataFormat={this.formatStatus.bind(this)} dataSort={ true }>Status</TableHeaderColumn>
                                </BootstrapTable>
                                ) : (
                                <BootstrapTable data={payouts} version='4' striped search pagination hover>
                                    <TableHeaderColumn dataField='payout_id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                    <TableHeaderColumn dataField='name' dataSort={ true }>Description</TableHeaderColumn>
                                    <TableHeaderColumn dataField='payout' dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Amount</TableHeaderColumn>
                                    <TableHeaderColumn dataField='status' width="120" dataFormat={this.formatStatus.bind(this)} dataSort={ true }>Status</TableHeaderColumn>
                                    <TableHeaderColumn dataField='created_at' dataFormat={this.formatDate} dataSort={ true }>Payment Date</TableHeaderColumn>
                                </BootstrapTable>
                                )
                            ) : (
                                <p class="col-md-12">No payouts yet.</p>
                            )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Owner/OwnerPayoutHistoryWidget.jsx